import i18next from "i18next";

export const appNameMap: Record<string, string> = {
  boersennews_de: "Börsennews",
  ariva_de: "Ariva",
  wso: "Wallstreet Online",
};

export const supportEmailMap: Record<string, string> = {
  boersennews_de: "info@boersennews.de",
  ariva_de: "info@ariva.de",
  wso: "feedback@wallstreet-online.de ",
};

export const getMandatorDefaultVariables = (mandatorSlug: string) => ({
  appName: appNameMap[mandatorSlug],
  supportEmail: supportEmailMap[mandatorSlug],
});

export const setMandatorDefaultVariables = (mandatorSlug: string) => {
  i18next.options.interpolation = {
    ...i18next.options.interpolation,
    defaultVariables: getMandatorDefaultVariables(mandatorSlug),
  };
};
